var _g, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgBackgroundMensagens(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 334,
    height: 340,
    viewBox: "0 0 334 340",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_1655_800)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M80.2945 21.7385C69.0724 38.083 82.2329 64.5961 65.5808 76.8895C49.3725 88.856 29.474 69.2426 14.1998 79.5396C-8.45452 94.8217 -4.32068 164.753 28.8084 208.206C38.7693 221.27 47.0954 226.36 50.7738 241.14C58.6911 272.871 30.8753 291.749 36.1652 307.44C48.0879 342.779 231.378 372.433 304.935 266.228C339.29 216.623 344.428 144.999 313.728 90.6071C258.271 -7.70485 105.459 -14.9431 80.2945 21.7385Z",
    fill: "#F4F7FA"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M206.563 293.523C201.88 291.97 198.377 288 197.396 283.109L190.577 249.381L132.271 251.447L125.089 286.588C124.085 291.503 128.102 296.441 132.738 298.262L157.132 307.801C161.675 309.575 166.544 310.287 171.39 309.867L222.947 305.454C224.453 305.326 225.668 304.146 225.843 302.617C226.018 301.099 227.069 299.395 225.632 298.916L206.563 293.523Z",
    fill: "#97A6B7"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M207.147 291.468C202.464 289.939 198.973 286.016 197.98 281.183L191.172 247.875L134.279 249.918L127.109 284.615C126.105 289.472 128.768 294.352 133.392 296.138L157.763 305.559C162.294 307.31 167.163 308.011 172.009 307.602L223.507 303.248C225.014 303.119 226.216 301.952 226.391 300.446C226.567 298.94 225.656 297.527 224.219 297.06L207.147 291.468Z",
    fill: "url(#paint0_linear_1655_800)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M13.1254 271.795C6.8079 272.169 1.63477 268.071 1.63477 262.654V67.3257C1.63477 61.9086 6.8079 57.7175 13.1254 57.9976L21.6967 63.7532L305.542 70.6646C310.19 70.8631 313.938 74.7741 313.938 79.3856V245.515C313.938 250.127 310.178 254.096 305.542 254.376L13.1254 271.795Z",
    fill: "#97A6B7"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M15.7529 271.795C9.43534 272.169 4.26221 268.071 4.26221 262.654V67.3257C4.26221 61.9086 9.43534 57.7175 15.7529 57.9976L308.169 70.6529C312.817 70.8514 316.565 74.7624 316.565 79.3739V245.504C316.565 250.115 312.805 254.085 308.169 254.365L15.7529 271.795Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.3,
    d: "M308.169 74.5643L15.7528 62.5395C12.378 62.3994 9.62207 64.6292 9.62207 67.5245V219.446V262.362C9.62207 265.258 12.3663 267.441 15.7528 267.254L308.169 250.466C310.656 250.326 312.665 248.201 312.665 245.726V207.748V79.2342C312.677 76.7591 310.656 74.6694 308.169 74.5643Z",
    fill: "#D8DEE8"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M15.7528 250.652C14.4333 250.722 13.3706 249.859 13.3706 248.726V67.6761C13.3706 66.5553 14.4449 65.6797 15.7528 65.7264L308.169 77.3076C309.138 77.3426 309.932 78.1599 309.932 79.1289V234.378C309.932 235.347 309.138 236.164 308.169 236.211L15.7528 250.652Z",
    fill: "url(#paint1_linear_1655_800)"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.6,
    d: "M277.644 242.282C253.04 227.07 270.229 183.816 242.6 162.078C214.749 140.165 175.548 167.039 156.046 144.344C141.52 127.451 158.522 107.044 144.649 91.1544C122.894 66.2291 67.204 100.506 41.6185 75.9541C37.9868 72.4634 34.3201 67.1748 32.2298 58.699L15.7529 57.9869C9.43534 57.7183 4.26221 61.8979 4.26221 67.3149V262.655C4.26221 268.072 9.43534 272.181 15.7529 271.796L308.169 254.377C312.817 254.097 316.565 250.128 316.565 245.516V242.563C297.157 249.147 285.293 247.011 277.644 242.282Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M258.061 239.33L78.0522 247.922V14.6515C78.0522 11.5344 80.6797 9.04769 83.7976 9.23449L252.946 19.1462C255.819 19.3097 258.061 21.6913 258.061 24.5633V239.33Z",
    fill: "#D8DEE8"
  }), /*#__PURE__*/React.createElement("g", {
    opacity: 0.75
  }, /*#__PURE__*/React.createElement("path", {
    opacity: 0.75,
    d: "M118.795 56.7264L94.2959 55.7924V33.4238L118.795 34.5913V56.7264Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.75,
    d: "M183.08 47.0127L124.517 44.4559V34.8711L183.08 37.6847V47.0127Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.75,
    d: "M166.171 58.5242L124.517 56.9364V47.3516L166.171 49.1261V58.5242Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.75,
    d: "M244.118 152.657L94.2959 153.521V146.457L244.118 146.061V152.657Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.75,
    d: "M244.118 162.78L94.2959 164.379V157.316L244.118 156.184V162.78Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.75,
    d: "M244.118 172.901L94.2959 175.224V168.161L244.118 166.305V172.901Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.75,
    d: "M244.118 183.01L94.2959 186.069V179.006L244.118 176.426V183.01Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.75,
    d: "M94.2959 62.5645V139.804L244.118 139.85V67.8064L94.2959 62.5645ZM187.237 100.46L180.768 106.274C180.523 106.496 180.417 106.811 180.476 107.115L182.006 115.521C182.134 116.209 181.468 116.746 180.803 116.606C180.593 116.641 180.359 116.618 180.126 116.501L172.08 112.438C171.986 112.392 171.893 112.368 171.799 112.345C171.706 112.357 171.613 112.392 171.519 112.427L163.403 116.314C163.182 116.419 162.936 116.443 162.726 116.396C162.049 116.525 161.371 115.964 161.5 115.275L163.053 106.835C163.111 106.519 162.995 106.204 162.749 105.971L156.14 99.8532C155.521 99.2811 155.86 98.3121 156.712 98.2071L165.832 97.1563C166.171 97.1213 166.463 96.9228 166.615 96.6427L170.667 89.0658C170.889 88.6455 171.367 88.4938 171.788 88.5755C172.22 88.5055 172.687 88.6922 172.909 89.1125L176.938 96.8528C177.089 97.1447 177.37 97.3431 177.708 97.3898L186.653 98.7908C187.506 98.9542 187.844 99.9232 187.237 100.46Z",
    fill: "white"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M329.539 78.4518C329.539 78.3584 329.527 78.265 329.527 78.1716C329.516 77.8914 329.504 77.6112 329.492 77.3193C329.492 77.2376 329.481 77.1559 329.481 77.0742C329.457 76.7473 329.434 76.4204 329.411 76.0935C329.411 76.0702 329.411 76.0585 329.411 76.0351C328.64 67.1157 324.915 58.9785 319.064 52.324C319.053 52.3473 319.053 52.359 319.041 52.3824C309.454 41.4783 294.016 35.2207 276.348 35.209C244.901 35.1973 218.299 56.5269 218.299 83.8104C218.299 95.3917 223.11 105.665 231.051 113.476C225.75 122.22 216.653 128.443 216.653 128.443C233.247 137.42 246.08 127.088 250.833 122.955C253.706 123.983 256.543 125.501 259.486 126.738C260.268 124.555 263.106 122.909 265.348 123.761C266.177 124.076 267.018 124.333 267.882 124.532C268.326 124.637 268.769 124.707 269.213 124.788C269.318 124.812 269.412 124.823 269.47 124.835C269.54 124.847 269.61 124.847 269.704 124.858C271.479 125.045 273.254 125.185 275.04 125.325C278.976 125.629 282.923 125.699 286.87 125.594C287.862 125.571 288.75 125.862 289.497 126.376C292.65 125.477 295.674 124.345 298.559 123.026C299.341 122.664 300.124 122.29 300.883 121.893C302.412 121.111 303.895 120.27 305.332 119.383C307.842 117.819 310.201 116.091 312.385 114.223C313.634 113.16 314.826 112.04 315.958 110.884C316.811 110.02 317.628 109.133 318.399 108.21C318.656 107.907 318.913 107.603 319.17 107.288C319.929 106.366 320.641 105.408 321.33 104.451C322.463 102.84 323.502 101.171 324.413 99.4544C324.775 98.7656 325.125 98.0768 325.464 97.3764C325.627 97.0261 325.791 96.6759 325.942 96.3256C326.258 95.6135 326.55 94.9013 326.818 94.1892C326.958 93.8273 327.087 93.4654 327.215 93.1034C327.472 92.3796 327.706 91.6441 327.916 90.9086C328.348 89.4376 328.687 87.9433 328.955 86.4256C329.084 85.6667 329.201 84.9079 329.282 84.1373C329.376 83.3668 329.434 82.608 329.481 81.8258C329.527 81.0552 329.551 80.273 329.551 79.5025C329.551 79.1756 329.539 78.8137 329.539 78.4518Z",
    fill: "url(#paint2_linear_1655_800)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M219.946 83.7059C219.946 110.989 246.664 131.058 278.111 128.63C308.018 126.318 331.209 104.335 331.209 79.433C331.209 54.5193 308.018 34.3222 278.111 34.3106C246.652 34.2989 219.946 56.4223 219.946 83.7059Z",
    fill: "url(#paint3_linear_1655_800)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M219.946 83.7059C219.946 110.989 246.664 131.058 278.111 128.63C308.018 126.318 331.209 104.335 331.209 79.433C331.209 54.5193 308.018 34.3222 278.111 34.3106C246.652 34.2989 219.946 56.4223 219.946 83.7059Z",
    fill: "url(#paint4_linear_1655_800)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M254.067 123.119C254.067 123.119 239.821 139.989 218.299 128.338C218.299 128.338 235.629 116.488 236.388 102.525L254.067 123.119Z",
    fill: "url(#paint5_linear_1655_800)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M296.06 80.7753C296.06 84.2427 298.652 86.9395 301.828 86.7994C304.993 86.6593 307.55 83.764 307.55 80.3317C307.55 76.8994 304.993 74.1909 301.828 74.2959C298.652 74.4127 296.06 77.308 296.06 80.7753Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M247.178 82.6551C247.178 86.2625 249.98 89.0644 253.425 88.9243C256.847 88.7726 259.614 85.7605 259.614 82.1764C259.614 78.604 256.847 75.8021 253.425 75.9072C249.98 76.0239 247.178 79.0476 247.178 82.6551Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M272.109 81.6973C272.109 85.2348 274.807 87.99 278.111 87.8382C281.405 87.6981 284.055 84.7327 284.055 81.2304C284.055 77.728 281.405 74.9728 278.111 75.0895C274.795 75.2063 272.109 78.1599 272.109 81.6973Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("g", {
    opacity: 0.3
  }, /*#__PURE__*/React.createElement("path", {
    opacity: 0.3,
    d: "M264.472 117.527C271.28 103.062 264.402 90.278 273.592 80.8333C282.794 71.3768 294.542 79.4089 306.932 71.6803C311.649 68.7383 316.858 63.2513 320.699 52.2188C327.309 59.7372 331.209 69.1353 331.209 79.4206C331.209 104.334 308.018 126.318 278.112 128.617C271.047 129.166 264.215 128.571 257.851 126.995C260.992 123.761 263.059 120.527 264.472 117.527Z",
    fill: "url(#paint6_linear_1655_800)"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M267.345 29.4667C267.345 29.3967 267.345 29.3383 267.333 29.2799C267.322 29.1048 267.322 28.9297 267.31 28.7545C267.31 28.6962 267.298 28.6261 267.298 28.5678C267.286 28.381 267.275 28.1942 267.251 27.9957C267.251 27.9607 267.24 27.914 267.24 27.879C266.714 22.1234 264.192 16.8114 260.245 12.3984C260.245 12.4101 260.245 12.4101 260.233 12.4218C253.811 5.25354 243.581 0.455269 231.892 0.12838C211.421 -0.432002 194.325 12.8887 194.325 29.887C194.325 44.9589 207.766 57.2406 225.084 59.5405C225.084 59.5405 225.084 59.5405 225.096 59.5405C225.329 59.5755 225.563 59.5989 225.796 59.6222C225.855 59.6339 225.925 59.6339 225.983 59.6456C226.182 59.6689 226.392 59.6923 226.59 59.704C226.684 59.7156 226.789 59.7273 226.882 59.7273C227.057 59.739 227.244 59.7623 227.419 59.774C227.548 59.7857 227.665 59.7974 227.793 59.7974C227.957 59.809 228.12 59.8207 228.284 59.8324C228.424 59.8441 228.576 59.8441 228.716 59.8557C228.867 59.8674 229.019 59.8674 229.159 59.8791C229.323 59.8908 229.486 59.8908 229.65 59.8908C229.778 59.8908 229.918 59.9024 230.047 59.9024C230.245 59.9024 230.432 59.9024 230.631 59.9141C230.736 59.9141 230.841 59.9141 230.946 59.9141C231.25 59.9141 231.553 59.9141 231.857 59.9024C236.983 59.7974 241.818 58.8284 246.185 57.1822C249.642 59.4004 256.356 61.9221 264.823 56.365C264.823 56.365 260.934 53.9601 257.886 50.1308C258.563 49.5237 259.217 48.8816 259.825 48.2278C260 48.041 260.175 47.8542 260.338 47.6674C260.677 47.2822 261.004 46.8969 261.319 46.5116C261.635 46.1147 261.938 45.7178 262.23 45.3092C263.41 43.6864 264.39 41.9702 265.185 40.1723C265.476 39.4952 265.745 38.8181 265.979 38.1176C266.13 37.6506 266.282 37.1836 266.411 36.7166C266.866 35.0705 267.158 33.366 267.263 31.6265C267.298 31.1362 267.31 30.6342 267.31 30.1322C267.345 29.922 267.345 29.7002 267.345 29.4667Z",
    fill: "url(#paint7_linear_1655_800)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M195.983 29.7815C195.983 46.7798 213.079 60.229 233.549 59.8203C253.378 59.4234 269.014 46.1027 269.014 30.0501C269.014 13.9974 253.389 0.559958 233.549 0.0229254C213.067 -0.537457 195.983 12.7716 195.983 29.7815Z",
    fill: "url(#paint8_linear_1655_800)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M259.579 50.0369C265.453 44.725 269.003 37.6969 269.003 30.0383C269.003 13.9857 253.379 0.548225 233.538 0.0111925C213.068 -0.549189 195.972 12.7716 195.972 29.7698C195.972 46.7681 213.068 60.2172 233.538 59.8086C238.665 59.7035 243.499 58.7345 247.867 57.0884C251.323 59.3066 258.038 61.8283 266.504 56.2712C266.516 56.2712 262.627 53.8662 259.579 50.0369Z",
    fill: "url(#paint9_linear_1655_800)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M245.403 29.9577C245.403 32.1642 247.131 33.9621 249.245 33.9621C251.358 33.9621 253.063 32.1875 253.063 29.981C253.063 27.7745 251.358 25.9883 249.245 25.9766C247.131 25.9649 245.403 27.7512 245.403 29.9577Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M213.406 29.8403C213.406 32.1052 215.217 33.9498 217.447 33.9498C219.666 33.9498 221.464 32.1285 221.464 29.8753C221.464 27.6221 219.666 25.7775 217.447 25.7658C215.217 25.7425 213.406 27.5754 213.406 29.8403Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M229.603 29.8989C229.603 32.1404 231.366 33.95 233.538 33.95C235.699 33.95 237.45 32.1521 237.45 29.9222C237.45 27.6924 235.699 25.8828 233.538 25.8712C231.378 25.8595 229.603 27.6574 229.603 29.8989Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.3,
    d: "M259.579 50.037C265.453 44.725 269.003 37.6969 269.003 30.0384C269.003 23.4072 266.364 17.2663 261.891 12.2812C259.299 19.2744 255.807 22.66 252.643 24.4345C244.387 29.046 236.621 23.6407 230.572 29.3962C224.57 35.1168 229.066 43.3941 224.617 52.3252C223.694 54.1698 222.351 56.1428 220.308 58.0808C224.442 59.295 228.914 59.9137 233.538 59.8203C238.665 59.7153 243.499 58.7463 247.867 57.1001C251.323 59.3183 258.038 61.84 266.504 56.2829C266.516 56.2712 262.627 53.8663 259.579 50.037Z",
    fill: "url(#paint10_linear_1655_800)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M204.403 141.624C204.403 141.624 202.815 133.311 201.215 130.836C199.627 128.361 196.649 126.773 196.649 126.773C196.649 126.773 196.03 127.789 198.004 129.937C199.977 132.085 198.331 132.296 198.004 132.984C197.677 133.673 198.389 136.148 199.802 137.035C201.215 137.923 201.752 142.744 201.752 142.744L204.403 141.624Z",
    fill: "url(#paint11_linear_1655_800)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M199.802 140.561C201.507 140.269 203.224 139.977 204.929 139.674C211.048 151.022 218.218 158.307 223.099 162.544C228.868 167.541 232.593 170.775 238.712 172.398C247.75 174.791 255.562 171.978 256.578 174.523C257.069 175.76 255.352 177.103 252.596 180.407C244.574 190.003 245.333 195.163 240.919 196.588C237.275 197.767 233.609 195.233 227.385 190.797C221.721 186.758 214.633 181.702 208.63 172.048C200.608 159.1 199.802 146.363 199.802 140.561Z",
    fill: "url(#paint12_linear_1655_800)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M275.157 175.549C275.986 175.864 288.668 180.907 291.272 194.135C291.482 195.209 293.514 206.568 285.807 214.6C277.166 223.602 260.514 223.38 253.904 215.85C252.363 214.098 251.545 212.149 251.09 210.514L252.83 205.891C254.955 203.323 257.851 202.716 259.393 202.342C263.199 201.408 266.072 203.101 268.256 201.268C269.459 200.252 269.704 198.793 269.914 197.485C270.638 193.037 268.127 190.294 267.952 187.55C267.812 185.496 267.1 181.001 269.774 178.071C271.479 176.214 273.826 175.712 275.157 175.549Z",
    fill: "url(#paint13_linear_1655_800)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M280.097 322.99C280.249 322.173 282.876 321.437 284.172 322.535C284.814 323.072 285.27 324.169 284.884 324.671C284.744 324.846 285.305 325.173 284.768 325.173C283.004 325.185 279.945 323.796 280.097 322.99Z",
    fill: "url(#paint14_linear_1655_800)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M282.853 323.279L285.562 322.894C284.312 321.388 284.546 316.578 284.546 316.578L281.673 317.22C281.673 317.22 282 318.539 282.561 320.489C282.736 321.155 282.817 322.194 282.853 323.279Z",
    fill: "url(#paint15_linear_1655_800)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M282.607 322.942C282.607 322.942 285.865 322.195 286.216 322.837C286.566 323.479 286.846 325.207 284.779 325.16C282.712 325.101 282.432 323.49 282.607 322.942Z",
    fill: "url(#paint16_linear_1655_800)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M242.974 326.037C243.231 325.254 245.94 324.893 247.084 326.153C247.645 326.784 247.937 327.928 247.493 328.372C247.33 328.535 247.843 328.92 247.306 328.85C245.555 328.628 242.717 326.819 242.974 326.037Z",
    fill: "url(#paint17_linear_1655_800)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M245.66 326.714H248.392C247.365 325.045 248.264 320.316 248.264 320.316L245.321 320.55C245.321 320.55 245.461 321.904 245.741 323.901C245.847 324.601 245.776 325.64 245.66 326.714Z",
    fill: "url(#paint18_linear_1655_800)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M238.583 223.416C237.322 227.596 235.512 234.344 234.344 242.796C231.028 266.928 238.081 267.698 236.761 294.445C236.341 302.979 244.165 322.674 244.854 323.106C245.193 323.141 245.555 323.164 245.94 323.153C246.617 323.129 247.575 323.024 248.696 322.697C249.934 322.487 254.394 310.392 253.367 303.201C252.631 298.111 252.841 292.647 253.273 281.731C253.343 279.957 257.874 247.303 257.874 247.303C259.252 259.398 260.84 269.66 262.207 277.633C266.621 303.224 280.972 318.705 281.72 318.95C281.872 319.008 283.214 319.499 284.312 318.775C284.803 318.448 284.966 318.039 284.966 318.039C285.351 317.736 284.849 292.495 280.482 273.489C274.129 245.913 276.897 239.457 274.888 227.141C273.125 216.482 238.583 223.416 238.583 223.416Z",
    fill: "url(#paint19_linear_1655_800)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M264.239 173.403C260.023 173.275 250.331 171.792 244.982 176.591C244.889 176.672 245.987 177.256 245.449 177.886C244.947 178.47 243.231 180.525 241.678 183.292C240.557 185.3 239.529 187.635 238.513 191.126C236.703 197.278 236.189 202.508 236.014 204.796C235.033 217.627 236.002 223.546 236.878 227.574C240.697 229.535 250.517 233.037 262.23 231.298C267.578 230.504 271.852 228.729 274.865 227.142C271.829 217.942 274.211 213.027 275.332 208.486C276.932 202.018 276.967 202.508 278.287 197.371C280.47 188.896 280.821 180.233 279.326 178.459C275.285 173.684 268.01 173.509 264.239 173.403Z",
    fill: "url(#paint20_linear_1655_800)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M245.473 326.35C245.473 326.35 248.801 326.059 249.058 326.747C249.315 327.436 249.35 329.187 247.306 328.837C245.263 328.51 245.216 326.864 245.473 326.35Z",
    fill: "url(#paint21_linear_1655_800)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M255.375 165.499C254.686 163.024 255.889 160.735 256.158 160.245C257.279 158.179 257.559 157.899 258.096 157.537L258.844 157.081C258.844 157.081 258.89 157.07 258.937 157.046C259.416 156.871 261.039 156.824 261.366 156.894C262.417 157.116 263.538 161.401 263.211 167.448C263.258 167.682 263.293 167.915 263.339 168.149C263.503 169.106 263.631 170.04 263.737 170.951C263.83 171.826 264.414 172.573 265.243 172.889C270.825 174.99 270.813 173.309 271.397 175.13C271.712 176.123 265.371 177.71 262.253 177.348C255.235 177.395 249.525 176.648 250.144 175.55C250.412 175.06 255.854 173.636 257.384 172.235C258.785 170.951 258.668 169.62 258.785 168.662C258.353 168.441 255.889 167.32 255.375 165.499Z",
    fill: "url(#paint22_linear_1655_800)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M256.672 155.365C256.683 157.233 257.559 159.241 258.015 159.556C258.073 159.603 258.4 159.86 258.692 160.303C258.727 160.362 258.762 160.432 258.797 160.525C259.206 161.704 257.326 163.094 257.688 163.619C257.956 164.004 259.229 163.491 259.381 163.817C259.521 164.133 258.458 164.775 258.622 165.148C258.739 165.429 259.393 165.172 259.813 165.604C260.023 165.814 259.953 165.989 260.175 166.643C260.303 167.016 260.467 167.425 260.607 167.647C261.249 168.744 263.094 169.153 263.445 168.709C263.538 168.581 263.456 168.487 263.561 168.067C263.561 168.067 263.655 167.682 263.923 167.25C264.297 166.619 265.22 166.164 266.142 165.499C267.859 164.261 268.314 163.21 268.454 162.86C268.501 162.732 268.536 162.638 268.559 162.568C269.003 161.191 269.003 159.159 268.384 157.91C267.345 155.82 264.998 156.813 263.071 154.746C260.852 152.353 262.172 149.096 260.969 148.734C259.638 148.349 256.66 151.898 256.672 155.365Z",
    fill: "#26264F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M258.365 163.188C258.82 162.557 259.626 163.152 259.638 163.97C259.638 164.787 258.855 165.639 258.084 165.476C257.314 165.312 257.746 164.04 258.365 163.188Z",
    fill: "url(#paint23_linear_1655_800)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M273.522 221.313C273.464 221.313 273.417 221.266 273.405 221.208C272.903 216.678 273.838 213.398 274.667 210.491C274.865 209.79 275.064 209.113 275.227 208.448C276.138 204.77 276.535 203.357 276.955 201.851C277.224 200.871 277.516 199.867 277.948 198.186C277.96 198.127 278.03 198.08 278.088 198.104C278.147 198.115 278.193 198.186 278.17 198.244C277.726 199.937 277.446 200.941 277.177 201.921C276.757 203.427 276.36 204.84 275.449 208.506C275.286 209.171 275.087 209.848 274.889 210.549C274.071 213.421 273.137 216.678 273.639 221.173C273.651 221.243 273.604 221.29 273.534 221.301C273.522 221.313 273.522 221.313 273.522 221.313Z",
    fill: "#9B305E"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M258.739 161.82L257.676 163.21C257.676 163.21 256.532 164.902 255.854 163.98C255.305 163.221 255.165 163.233 255.13 163.268C255.119 163.28 255.119 163.28 255.119 163.28C255.107 163.28 255.2 162.906 255.282 162.567C255.002 162.976 254.605 163.63 254.371 164.529C254.138 165.393 253.892 166.315 254.383 167.202C254.406 167.249 254.943 168.195 255.948 168.428C255.948 168.428 256.345 168.522 258.003 168.23C258.003 168.23 256.181 166.91 256.158 166.595C256.088 165.743 257.267 165.276 258.143 163.536C258.482 162.848 258.645 162.241 258.739 161.82Z",
    fill: "#26264F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M10.9887 99.0006C10.9887 98.9072 11.0004 98.8138 11.0004 98.7204C11.0121 98.4402 11.0238 98.16 11.0354 97.8682C11.0354 97.7865 11.0471 97.7047 11.0471 97.623C11.0705 97.2961 11.0938 96.9692 11.1172 96.6423C11.1172 96.619 11.1172 96.6073 11.1172 96.584C11.8879 87.6646 15.613 79.5273 21.4635 72.8728C21.4751 72.8962 21.4751 72.9078 21.4868 72.9312C31.074 62.0271 46.5117 55.7695 64.1798 55.7578C95.6273 55.7461 122.229 77.0757 122.229 104.359C122.229 115.94 117.418 126.214 109.477 134.024C114.778 142.769 123.875 148.991 123.875 148.991C107.281 157.969 94.4479 147.637 89.6951 143.504C86.8225 144.532 83.9848 146.049 81.0421 147.287C80.2597 145.104 77.4221 143.458 75.18 144.31C74.3509 144.625 73.5101 144.882 72.646 145.08C72.2022 145.185 71.7585 145.255 71.3147 145.337C71.2096 145.361 71.1162 145.372 71.0578 145.384C70.9878 145.396 70.9177 145.396 70.8243 145.407C69.0493 145.594 67.2626 145.734 65.4877 145.874C61.5523 146.178 57.6053 146.248 53.6583 146.143C52.6657 146.119 51.7783 146.411 51.0309 146.925C47.878 146.026 44.8535 144.894 41.9692 143.574C41.1868 143.212 40.4044 142.839 39.6453 142.442C38.1156 141.66 36.6325 140.819 35.1962 139.932C32.6855 138.367 30.3267 136.64 28.143 134.772C26.8935 133.709 25.7024 132.589 24.5697 131.433C23.7172 130.569 22.8998 129.682 22.1291 128.759C21.8722 128.456 21.6153 128.152 21.3584 127.837C20.5993 126.915 19.887 125.957 19.198 125C18.0653 123.389 17.026 121.719 16.1152 120.003C15.7532 119.314 15.4028 118.626 15.0642 117.925C14.9007 117.575 14.7372 117.225 14.5854 116.874C14.2701 116.162 13.9782 115.45 13.7096 114.738C13.5695 114.376 13.441 114.014 13.3126 113.652C13.0556 112.928 12.8221 112.193 12.6119 111.457C12.1798 109.986 11.8412 108.492 11.5726 106.974C11.4442 106.216 11.3274 105.457 11.2456 104.686C11.1522 103.916 11.0938 103.157 11.0471 102.375C11.0004 101.604 10.9771 100.822 10.9771 100.051C10.9771 99.7244 10.9771 99.3625 10.9887 99.0006Z",
    fill: "url(#paint24_linear_1655_800)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M120.581 104.243C120.581 131.527 93.863 151.595 62.4155 149.167C32.5094 146.867 9.31787 124.884 9.31787 99.9701C9.31787 75.0564 32.5094 54.8593 62.4155 54.8477C93.863 54.8477 120.581 76.9594 120.581 104.243Z",
    fill: "url(#paint25_linear_1655_800)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M120.581 104.243C120.581 131.527 93.863 151.595 62.4155 149.167C32.5094 146.867 9.31787 124.884 9.31787 99.9701C9.31787 75.0564 32.5094 54.8593 62.4155 54.8477C93.863 54.8477 120.581 76.9594 120.581 104.243Z",
    fill: "url(#paint26_linear_1655_800)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M86.4604 143.668C86.4604 143.668 100.707 160.538 122.229 148.887C122.229 148.887 104.899 137.037 104.14 123.074L86.4604 143.668Z",
    fill: "url(#paint27_linear_1655_800)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M44.4682 101.324C44.4682 104.792 41.8758 107.488 38.6995 107.348C35.5349 107.208 32.9775 104.313 32.9775 100.881C32.9775 97.4482 35.5349 94.7397 38.6995 94.8448C41.8758 94.9498 44.4682 97.8568 44.4682 101.324Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M93.3501 103.204C93.3501 106.811 90.5475 109.613 87.1027 109.473C83.6811 109.321 80.9136 106.309 80.9136 102.725C80.9136 99.1528 83.6811 96.3509 87.1027 96.456C90.5358 96.5727 93.3501 99.5965 93.3501 103.204Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M68.4187 102.246C68.4187 105.784 65.7212 108.539 62.4165 108.387C59.1234 108.247 56.4727 105.282 56.4727 101.779C56.4727 98.2768 59.1234 95.5216 62.4165 95.6383C65.7212 95.7434 68.4187 98.7088 68.4187 102.246Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("g", {
    opacity: 0.3
  }, /*#__PURE__*/React.createElement("path", {
    opacity: 0.3,
    d: "M76.0441 138.075C69.2361 123.611 76.1141 110.827 66.9239 101.382C57.7221 91.9256 45.9745 99.9578 33.5847 92.2292C28.8669 89.2872 23.6588 83.8001 19.8169 72.7676C13.2074 80.286 9.30713 89.6841 9.30713 99.9695C9.30713 124.883 32.4987 146.866 62.4047 149.166C69.4696 149.715 76.301 149.12 82.6652 147.544C79.524 144.31 77.457 141.076 76.0441 138.075Z",
    fill: "url(#paint28_linear_1655_800)"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M73.1832 50.0012C73.1832 49.9311 73.1832 49.8727 73.1949 49.8144C73.2066 49.6392 73.2066 49.4641 73.2183 49.289C73.2183 49.2306 73.23 49.1606 73.23 49.1022C73.2416 48.9154 73.2533 48.7286 73.2767 48.5302C73.2767 48.4951 73.2883 48.4484 73.2883 48.4134C73.8138 42.6578 76.3362 37.3459 80.2832 32.9329C80.2832 32.9445 80.2832 32.9445 80.2948 32.9562C86.7292 25.788 96.947 20.9781 108.636 20.6628C129.107 20.1141 146.203 33.4349 146.203 50.4331C146.203 65.5051 132.762 77.7868 115.444 80.0867C115.444 80.0867 115.444 80.0867 115.432 80.0867C115.199 80.1217 114.965 80.145 114.732 80.1684C114.673 80.1801 114.603 80.1801 114.545 80.1917C114.346 80.2151 114.136 80.2384 113.938 80.2501C113.844 80.2618 113.739 80.2734 113.646 80.2734C113.471 80.2851 113.284 80.3085 113.109 80.3201C112.98 80.3318 112.863 80.3435 112.735 80.3435C112.572 80.3552 112.408 80.3668 112.245 80.3785C112.104 80.3902 111.953 80.3902 111.812 80.4019C111.661 80.4135 111.509 80.4135 111.369 80.4252C111.205 80.4369 111.042 80.4369 110.878 80.4369C110.75 80.4369 110.61 80.4486 110.481 80.4486C110.283 80.4486 110.096 80.4486 109.897 80.4602C109.792 80.4602 109.687 80.4602 109.582 80.4602C109.278 80.4602 108.975 80.4602 108.671 80.4486C103.545 80.3435 98.7103 79.3745 94.3429 77.7284C90.8864 79.9466 84.1718 82.4683 75.7056 76.9112C75.7056 76.9112 79.5942 74.5062 82.642 70.6769C81.9647 70.0698 81.3108 69.4277 80.7036 68.7739C80.5284 68.5872 80.3532 68.4004 80.1898 68.2136C79.8511 67.8283 79.5241 67.443 79.2088 67.0578C78.8935 66.6608 78.5899 66.2639 78.298 65.8553C77.1186 64.2325 76.1377 62.5163 75.3436 60.7185C75.0516 60.0413 74.7831 59.3642 74.5495 58.6637C74.3977 58.1967 74.2459 57.7298 74.1174 57.2628C73.662 55.6167 73.3701 53.9122 73.265 52.1726C73.23 51.6823 73.2183 51.1803 73.2183 50.6783C73.1716 50.4681 73.1716 50.2347 73.1832 50.0012Z",
    fill: "url(#paint29_linear_1655_800)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M144.544 50.3167C144.544 67.3149 127.448 80.7641 106.978 80.3555C87.1494 79.9585 71.5132 66.6378 71.5132 50.5852C71.5132 34.5326 87.1377 21.0951 106.978 20.5581C127.448 19.9977 144.544 33.3184 144.544 50.3167Z",
    fill: "url(#paint30_linear_1655_800)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M80.9369 70.5838C75.0631 65.2719 71.5132 58.2437 71.5132 50.5852C71.5132 34.5326 87.1377 21.0951 106.978 20.5581C127.448 19.9977 144.544 33.3184 144.544 50.3167C144.544 67.3149 127.448 80.7641 106.978 80.3555C101.851 80.2504 97.0169 79.2814 92.6495 77.6353C89.1929 79.8535 82.4784 82.3752 74.0122 76.8181C74.0005 76.8181 77.9008 74.4131 80.9369 70.5838Z",
    fill: "url(#paint31_linear_1655_800)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M95.1135 50.5045C95.1135 52.711 93.3853 54.5089 91.2717 54.5089C89.158 54.5089 87.4531 52.7344 87.4531 50.5279C87.4531 48.3331 89.158 46.5352 91.2717 46.5235C93.397 46.5118 95.1135 48.2864 95.1135 50.5045Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M127.11 50.3872C127.11 52.652 125.3 54.4966 123.07 54.4966C120.851 54.4966 119.052 52.6754 119.052 50.4222C119.052 48.169 120.851 46.3244 123.07 46.3127C125.3 46.2894 127.11 48.1106 127.11 50.3872Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M110.913 50.4458C110.913 52.6873 109.15 54.4969 106.978 54.4969C104.818 54.4969 103.066 52.699 103.066 50.4691C103.066 48.2393 104.818 46.4297 106.978 46.418C109.15 46.4064 110.913 48.2042 110.913 50.4458Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.3,
    d: "M80.9369 70.5838C75.0631 65.2719 71.5132 58.2438 71.5132 50.5852C71.5132 43.954 74.1523 37.8132 78.6248 32.8281C81.2172 39.8212 84.7088 43.2069 87.8734 44.9814C96.1294 49.5929 103.895 44.1875 109.944 49.9431C115.946 55.6637 111.45 63.941 115.899 72.8721C116.822 74.7167 118.165 76.6897 120.208 78.6277C116.075 79.8418 111.602 80.4606 106.978 80.3672C101.851 80.2621 97.0169 79.2931 92.6495 77.647C89.1929 79.8652 82.4784 82.3869 74.0122 76.8298C74.0005 76.8181 77.9008 74.4131 80.9369 70.5838Z",
    fill: "url(#paint32_linear_1655_800)"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_1655_800",
    x1: 176.667,
    y1: 262.545,
    x2: 176.667,
    y2: 295.049,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.494,
    stopColor: "#EBEFF2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_1655_800",
    x1: 183.117,
    y1: 72.4288,
    x2: 72.0274,
    y2: 479.314,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFC444"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9964,
    stopColor: "#F36F56"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_1655_800",
    x1: 244.872,
    y1: 42.6609,
    x2: 321.889,
    y2: 197.253,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#311944"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#893976"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint3_linear_1655_800",
    x1: 296.795,
    y1: 42.1255,
    x2: 218.17,
    y2: 187.989,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFC444"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9964,
    stopColor: "#F36F56"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint4_linear_1655_800",
    x1: 296.795,
    y1: 42.1255,
    x2: 218.17,
    y2: 187.989,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FF9085"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FB6FBB"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint5_linear_1655_800",
    x1: 301.485,
    y1: 38.8394,
    x2: 195.136,
    y2: 178.763,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FF9085"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FB6FBB"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint6_linear_1655_800",
    x1: 318.869,
    y1: 51.0091,
    x2: 242.406,
    y2: 204.49,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FF9085"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FB6FBB"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint7_linear_1655_800",
    x1: 216.726,
    y1: 1.73988,
    x2: 273.371,
    y2: 115.44,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#311944"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#893976"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint8_linear_1655_800",
    x1: 245.783,
    y1: 5.23044,
    x2: 196.585,
    y2: 96.5013,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFC444"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9964,
    stopColor: "#F36F56"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint9_linear_1655_800",
    x1: 225.213,
    y1: 21.5949,
    x2: 356.4,
    y2: 172.101,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.00359712,
    stopColor: "#E38DDD"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#9571F6"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint10_linear_1655_800",
    x1: 236.53,
    y1: 24.7979,
    x2: 270.025,
    y2: 92.0295,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.00359712,
    stopColor: "#E38DDD"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#9571F6"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint11_linear_1655_800",
    x1: 197.917,
    y1: 128.615,
    x2: 206.044,
    y2: 147.324,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#311944"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#893976"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint12_linear_1655_800",
    x1: 218.709,
    y1: 142.055,
    x2: 251.677,
    y2: 217.953,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.00359712,
    stopColor: "#E38DDD"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#9571F6"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint13_linear_1655_800",
    x1: 268.174,
    y1: 219.154,
    x2: 279.123,
    y2: 175.347,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.00359712,
    stopColor: "#E38DDD"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#9571F6"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint14_linear_1655_800",
    x1: 278.633,
    y1: 320.634,
    x2: 284.425,
    y2: 324.483,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#444B8C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9964,
    stopColor: "#26264F"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint15_linear_1655_800",
    x1: 284.238,
    y1: 324.516,
    x2: 282.971,
    y2: 315.554,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFC444"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9964,
    stopColor: "#F36F56"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint16_linear_1655_800",
    x1: 279.068,
    y1: 319.978,
    x2: 284.86,
    y2: 323.827,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#444B8C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9964,
    stopColor: "#26264F"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint17_linear_1655_800",
    x1: 241.854,
    y1: 323.506,
    x2: 247.049,
    y2: 328.128,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#444B8C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9964,
    stopColor: "#26264F"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint18_linear_1655_800",
    x1: 246.859,
    y1: 328.137,
    x2: 246.859,
    y2: 319.086,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFC444"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9964,
    stopColor: "#F36F56"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint19_linear_1655_800",
    x1: 246.433,
    y1: 332.286,
    x2: 280.302,
    y2: 195.506,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#444B8C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9964,
    stopColor: "#26264F"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint20_linear_1655_800",
    x1: 228.2,
    y1: 134.126,
    x2: 264.515,
    y2: 217.729,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.00359712,
    stopColor: "#E38DDD"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#9571F6"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint21_linear_1655_800",
    x1: 242.376,
    y1: 322.917,
    x2: 247.572,
    y2: 327.54,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#444B8C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9964,
    stopColor: "#26264F"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint22_linear_1655_800",
    x1: 251.893,
    y1: 155.127,
    x2: 269.172,
    y2: 194.777,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#311944"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#893976"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint23_linear_1655_800",
    x1: 254.094,
    y1: 153.942,
    x2: 272.158,
    y2: 195.394,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#311944"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#893976"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint24_linear_1655_800",
    x1: 95.6498,
    y1: 63.2051,
    x2: 18.6329,
    y2: 217.798,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#311944"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#893976"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint25_linear_1655_800",
    x1: 43.7255,
    y1: 62.6696,
    x2: 122.351,
    y2: 208.533,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFC444"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9964,
    stopColor: "#F36F56"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint26_linear_1655_800",
    x1: 43.7255,
    y1: 62.6696,
    x2: 122.351,
    y2: 208.533,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FF9085"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FB6FBB"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint27_linear_1655_800",
    x1: 39.0366,
    y1: 59.3836,
    x2: 145.386,
    y2: 199.308,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FF9085"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FB6FBB"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint28_linear_1655_800",
    x1: 21.6526,
    y1: 71.5532,
    x2: 98.1159,
    y2: 225.034,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FF9085"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FB6FBB"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint29_linear_1655_800",
    x1: 123.796,
    y1: 22.2814,
    x2: 67.151,
    y2: 135.982,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#311944"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#893976"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint30_linear_1655_800",
    x1: 94.7376,
    y1: 25.7726,
    x2: 143.936,
    y2: 117.043,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFC444"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9964,
    stopColor: "#F36F56"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint31_linear_1655_800",
    x1: 115.309,
    y1: 42.1371,
    x2: -15.8779,
    y2: 192.643,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.00359712,
    stopColor: "#E38DDD"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#9571F6"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint32_linear_1655_800",
    x1: 103.991,
    y1: 45.3401,
    x2: 70.4971,
    y2: 112.572,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.00359712,
    stopColor: "#E38DDD"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#9571F6"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_1655_800"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 334,
    height: 340,
    fill: "white"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgBackgroundMensagens);
export default __webpack_public_path__ + "static/media/background-mensagens.dbc6b29957016159eff02419ef1bc238.svg";
export { ForwardRef as ReactComponent };